import { render, staticRenderFns } from "./DiscoveryExpertsCard.vue?vue&type=template&id=23a30bda"
import script from "./DiscoveryExpertsCard.vue?vue&type=script&lang=js"
export * from "./DiscoveryExpertsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports